import React from "react";
import { Link } from "react-router-dom";
import {past_events, future_events} from "../../api/event";

const EventSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`wpo-event-area ${props.evCLass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="wpo-section-title">
              <span>Events</span>
              <h2>Completed Events</h2>
              <p>
                At Hill Academy, our events are designed to inspire, educate,
                and bring youth together. Take a look at what we've
                accomplished!
              </p>{" "}
            </div>
          </div>
        </div>
        <div className="wpo-event-wrap">
          <div className="row">
            {past_events.slice(0, 2).map((event, eitem) => (
              <div className="col col-lg-4 col-md-6 col-12" key={eitem}>
                <div className="wpo-event-single">
                  <div className="wpo-event-item">
                    <div className="wpo-event-img">
                      <img src={event.eImg} alt="" />
                    </div>
                    <div className="wpo-event-content">
                      <div className="wpo-event-text-top">
                        <span>{event.date}</span>
                        <h2>
                          <Link
                            onClick={ClickHandler}
                            to={`/event-single/${event.id}`}
                          >
                            {event.eTitle}
                          </Link>
                        </h2>
                        <p>{event.short_desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="wpo-section-title">
              <h2>Future Events</h2>
              <p>
See upcoming events Hill Academy has planned and have a chance to register. We look forward to seeing you there!
              </p>{" "}
            </div>
          </div>
        </div>
        <div className="wpo-event-wrap">
          <div className="row">
            {future_events.slice(0, 2).map((event, eitem) => (
              <div className="col col-lg-4 col-md-6 col-12" key={eitem}>
                <div className="wpo-event-single">
                  <div className="wpo-event-item">
                    <div className="wpo-event-img">
                      <img src={event.eImg} alt="" />
                    </div>
                    <div className="wpo-event-content">
                      <div className="wpo-event-text-top">
                        <span>{event.date}</span>
                        <h2>
                          <Link
                            onClick={ClickHandler}
                            to={`/event-single/${event.id}`}
                          >
                            {event.eTitle}
                          </Link>
                        </h2>
                        <p>{event.short_desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSection;
